import { useEffect } from 'react';

// hooks
import useAuth from '../../hooks/useAuth';

import { Box, Typography } from '@mui/material';

export default function Logout() {
    const { logout } = useAuth();

    const handleLogout = async () => {
        try {
            await logout();
            
            window.location.href = "/auth/login";
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(async () => {
        handleLogout();
    }, []);

    return (
        <></>
    );

  }